import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import '@/styles/index.scss'
import '@/icons' // icon
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(ElementUI, {
  size: 'mini' // set element-ui default size
})
Vue.use(Vant);

Vue.config.productionTip = false


new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
